import styled from 'styled-components';
import { colours, spacing, fontSize } from '../../../theme';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Hr = styled.hr`
  margin: ${spacing.medium};
  border: none;
  height: ${spacing.medium};
  background-color: ${colours.yellow};
`;

export const Ul = styled.ul`
  list-style-type: none;
  line-height: ${spacing.medium};
  margin: ${spacing.medium};
  padding: 0;
  max-width: 55em;
`;

export const Li = styled.li`
  text-decoration: underline;
  font-size: ${fontSize.small};
  cursor: pointer;
  margin-bottom: ${spacing.small};
  color: ${colours.black};
`;

export const AnswerBox = styled.section`
  margin: ${spacing.medium};
  text-align: ${props => props.align};
  max-width: 55em;
  float: ${props => props.align};
`;

export const Question = styled.h2`
  font-size: ${fontSize.medium};
`;

export const Answer = styled.p`
  line-height: ${spacing.small};
  font-size: ${fontSize.small};
`;